var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:'search-filter-label ' + _vm.classes},[_vm._v(_vm._s(_vm.title)+" "),_c('img',{attrs:{"src":require("@/assets/images/svg/close.svg"),"alt":""},on:{"click":_vm.onClickCross}})])}
var staticRenderFns = []

export { render, staticRenderFns }